<template>
  <div v-if="visible" role="alert" :class="[baseCss, type !== 'custom' ? setTypeBgColor : setBgColor(), setColor ? setColor : setTextColor(), rounded ? 'rounded' : null, `shadow-${elevation}`]" :hidden="hidden">
    <table-layout y-align="middle">
      <row>
        <cell x-align="center" :class="['p-2']">
          <icon :provider="iconProvider" :name="setIcon" :color="setColor.replace('text-', '')" />
        </cell>
        <cell x-align="left" full-width :class="['p-2', 'text-sm']">
          <slot />
        </cell>
        <cell x-align="center" v-if="dismissible" :class="['p-2']">
          <icon :provider="iconProvider" name="close-circle-outline" @click.native="dismiss" :color="setColor.replace('text-', '')" :class="['cursor-pointer']" />
        </cell>
      </row>
    </table-layout>
    <div :class="['bcq-alert-bar']" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Alert',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('alert', ['shadow', 'block', 'overflow-hidden']),
      hidden: false,
      types: {
        info: {
          icon: 'information',
          bgColor: 'bg-blue-500',
          color: 'white'
        },
        success: {
          icon: 'checkbox-marked-circle',
          bgColor: 'bg-green-500',
          color: 'white'
        },
        warning: {
          icon: 'alert-outline',
          bgColor: 'bg-yellow-500',
          color: 'white'
        },
        error: {
          icon: 'alert',
          bgColor: 'bg-red-500',
          color: 'white'
        }
      }
    }
  },
  model: {
    prop: 'visible',
    event: 'dismiss'
  },
  props: {
    value: false,
    visible: {
      type: Boolean
    },
    rounded: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'info',
      validator: value => {
        return ['info', 'success', 'warning', 'error', 'custom'].includes(value)
      }
    },
    icon: {
      type: String
    },
    dismissible: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String,
      default: 'blue'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  computed: {
    setIcon () {
      return !this.icon && this.type ? this.types[this.type].icon : this.icon
    },
    setTypeBgColor () {
      return this.types[this.type].bgColor
    },
    setColor () {
      const type = this.types[this.type]
      return type ? `text-${type.color}` : ''
    }
  },
  methods: {
    dismiss (event) {
      this.$emit('dismiss', event.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/alert/alert.vue